import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import WButton from "../wbutton/WButton";
import { useRouter } from "next/router";
import clsx from "clsx";
import LCountDownTimer from "../lcount-down-timer/LCountDownTimer";
import parse from "html-react-parser";
import fbEvent from "@/utils/fbEvent";

/* eslint-disable-next-line */
export interface LDarkSimpleWithBackgroundProps {
  id?: string;
  backgroundImageUrl?: string;
  mainTitle: string;
  secondaryTitle: string; //rich text
  button?: {
    text: string;
    url: string;
  };
  image: {
    url: string;
    altTag: string;
  };
  centerText?: boolean;
  countDownTimer?: {
    endDate: Date;
    description?: string;
  };
}

export function LDarkSimpleWithBackground(
  props: LDarkSimpleWithBackgroundProps
) {
  const router = useRouter();
  return (
    <div
      id={props?.id}
      className="py-20 bg-ekblue"
      style={{
        backgroundImage: `url('${props?.backgroundImageUrl}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "top right",
      }}
    >
      <div
        className={clsx([
          props?.centerText && "text-center justify-center items-center",
          "container flex flex-col gap-10 px-4 mx-auto mt-10 text-white lg:max-w-7xl",
        ])}
      >
        <img
          src={props?.image?.url}
          alt={props?.image?.altTag}
          className="mx-auto w-fit"
        />
        <h1 className="text-white">{parse(props?.mainTitle)}</h1>
        <div
          className={clsx([
            props?.centerText && "mx-auto",
            "max-w-4xl white-markdown",
          ])}
        >
          <ReactMarkdown>{props?.secondaryTitle}</ReactMarkdown>
        </div>
        {props?.button?.text && props?.button?.url && (
          <div
            className={clsx([
              props?.centerText && "flex justify-center w-full",
            ])}
          >
            <WButton
              text={props?.button?.text}
              type="primary-red-btn"
              className="mx-auto w-fit lg:mx-0"
              onClick={() => {
                props?.button?.url && router.push(props?.button.url);
                fbEvent("Schedule");
              }}
            />
          </div>
        )}
        {props?.countDownTimer && (
          <div>
            <LCountDownTimer
              endDate={new Date(props?.countDownTimer?.endDate)}
              description={props?.countDownTimer?.description}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default LDarkSimpleWithBackground;
